import React from 'react';
import Slider from "react-slick"; // Import react-slick for carousel
import "../styles/Buy.css"
import fs1 from "../assets/images/fs1.png"
import fs3 from "../assets/images/fs3.png"
import fs2 from "../assets/images/fs2.webp"
import fs4 from "../assets/images/fs4.webp"
import fs5 from "../assets/images/fs5.webp"
import fs6 from "../assets/images/fs6.webp"
const TrustedBrandsHaro = () => {
  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 2000,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    rtl: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };

  return (
    <article className="containerPartener">
      <h2>Our Trade Marks</h2>
      <section className="customer-logos trsutedBrandsImg" dir="rtl">
        <Slider {...settings} className="slick customer-logos">
          <div className="slide">
            <img src={fs1} alt="Brand 2" />
          </div>
          <div className="slide">
            <img src={fs2} alt="Brand 4" />
          </div>
          <div className="slide">
            <img src={fs3} alt="Brand 4" />
          </div>
          <div className="slide">
            <img src={fs4} alt="Brand 4" />
          </div> 
            <div className="slide">
            <img src={fs5} alt="Brand 4" />
          </div>
            <div className="slide">
            <img src={fs6} alt="Brand 4" />
          </div>



        </Slider>
      </section>
    </article>
  );
};

export default TrustedBrandsHaro;
